export default "__VITE_ASSET__Bw05kY69__"